<!-- src/components/Popup.vue -->
<template>
  <div
    v-if="show"
    class="gift-popup"
    :style="{ left: x + 'px', top: y + 'px' }"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="gift-popup-item" v-for="(item,index) in list" :key="index" @click="handleZs(item)">{{item}}</div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    }
  },
  data(){
	  return{
		  list:[1,10,66,188,520,999,1314,5200]
	  }
  },
  methods:{
	  handleZs(data){
		  console.log(123123)
		  this.$emit('giveGif',data)
	  }
  }
}
</script>

<style scoped>
.gift-popup {
    position: fixed;
    z-index: 9999;
    transform: translateX(-50%) translateY(-100%) translateY(-10px);
	background: #252632;
	border-radius: 20px 20px 20px 20px;
	padding: 16px 11px 0px 11px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	width: 352px;
}
.gift-popup-item{
	width: 78px;
	height: 30px;
	background: rgba(255,255,255,0.08);
	border-radius: 20px 20px 20px 20px;
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 14px;
	color: #FFFFFF;
	text-align: center;
	line-height: 30px;
	cursor: pointer;
	margin: 0px 5px 16px 5px;
}
</style>


// WEBPACK FOOTER //
// popup.vue?128cbd5e